export default "__VITE_ASSET__CiPyZPhL__"